import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { auth } from '../../config/supabase';
import './AdminLayout.css';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `admin-nav-link${isActive ? ' active' : ''}`;

const AdminLayout: React.FC = () => {
  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <div className="admin-app">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <div className="admin-sidebar-brand">BorisMetrics</div>
          <div className="admin-sidebar-tagline">Administración</div>
        </div>

        <nav className="admin-sidebar-nav">
          <NavLink to="/admin" end className={navLinkClass}>
            Dashboard
          </NavLink>
          <NavLink to="/admin/stores" className={navLinkClass}>
            Tiendas
          </NavLink>
          <NavLink to="/admin/users" className={navLinkClass}>
            Usuarios
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <button type="button" className="admin-logout-btn" onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
